import * as remote from './remote';

export default {
  remote,
};
